module.exports = __webpack_public_path__ + "img/icon-check.847d05dc.svg";